// extracted by mini-css-extract-plugin
export default {"root":"_2GhZr","title":"_2ja1F","phone":"_3b1U-"};